/** Session keys aligned with {@link AuthService} (read from storage only — safe for interceptors). */
const SESSION_KIND_KEY = 'LYCHEE_SESSION_KIND';
const PROVIDER_PORTAL_KEY = 'LYCHEE_PROVIDER_PORTAL_KIND';

/**
 * @deprecated The store portal is translated now and follows the user's language preference like
 * every other portal. Kept only so older imports keep compiling.
 */
export const STORE_FORCED_LANGUAGE = 'en';

export type ActivePortal = 'store' | 'taxi' | 'transit' | 'guest';

export function getActivePortal(): ActivePortal {
  const kind = localStorage.getItem(SESSION_KIND_KEY);
  const portal = localStorage.getItem(PROVIDER_PORTAL_KEY);
  if (kind === 'PROVIDER' && portal === 'TAXI_OFFICE') {
    return 'taxi';
  }
  if (kind === 'PROVIDER' && portal === 'TRANSIT_OPERATOR') {
    return 'transit';
  }
  if (kind === 'STORE') {
    return 'store';
  }
  if (localStorage.getItem('LYCHEE_STORE_TOKEN') && localStorage.getItem('store')) {
    return 'store';
  }
  return 'guest';
}

export function isTaxiOfficePortalActive(): boolean {
  return getActivePortal() === 'taxi';
}

export function isStorePortalActive(): boolean {
  return getActivePortal() === 'store';
}
